export const AUTH_INIT = "auth/init";
export const AUTH_LOGIN = "auth/login";
export const AUTH_SIGN_OUT = "auth/signout";
export const REFRESH_TOKEN = "auth/token";
